<template>
	<span class="activity-resource-summary">
		<strong>{{ title }}</strong>
		<span v-if="summary">{{ summary }}</span>
	</span>
</template>

<script setup lang="ts">
defineProps<{
	title: string
	summary?: string | null
}>()
</script>

<style scoped>
.activity-resource-summary {
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: var(--spacing-xs);
	min-width: 0;

	strong {
		overflow: hidden;
		color: var(--neutral-900);
		font-size: var(--font-size-regular);
		font-weight: var(--font-weight-semibold);
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	span {
		color: var(--neutral-500);
		font-size: var(--font-size-xs);
	}
}
</style>
